import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// routes
import { CURD_API_MANAGEMENT_CHR } from "../../../utils/routes";

// ---------------------------------------------------------------------

export const createApiManagementChr = createAsyncThunk(
  "apiManagementChr/createApiManagementChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(CURD_API_MANAGEMENT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getApiManagementChr = createAsyncThunk(
  "apiManagementChr/getApiManagementChr",
  async (obj, {rejectWithValue}) => {
    try {
      const response = await axios.get(CURD_API_MANAGEMENT_CHR, { withCredentials: true });
      return response;
    } catch (err) {
      return rejectWithValue(err.response)
    }
  }
);

export const updateApiManagementChr = createAsyncThunk(
  "apiManagementChr/updateApiManagementChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put(CURD_API_MANAGEMENT_CHR, data, {
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteApiManagementChr = createAsyncThunk(
  "apiManagementChr/deleteApiManagementChr",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.delete(CURD_API_MANAGEMENT_CHR, {
        data,
        withCredentials: true,
      });
      return response;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const apiManagementChrSlice = createSlice({
  name: "apiManagementChr",
  initialState: {
    loading: false,
    message: "",
    errMessage: "",
    apiManagementData: [],
    selectedData: {},
  },
  reducers: {
    resetMessage: (state) => {
      state.message = "";
    },
    resetErrMessage: (state) => {
      state.errMessage = "";
    },
    rowSelect: (state, action) => {
      state.selectedData = action?.payload.length > 0 && action?.payload[0];
    },
  },
  extraReducers: {
    [createApiManagementChr.pending]: (state, action) => {
      state.loading = true;
    },
    [createApiManagementChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [createApiManagementChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [getApiManagementChr.pending]: (state, action) => {
      state.loading = true;
    },
    [getApiManagementChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.apiManagementData = action?.payload?.data;
    },
    [getApiManagementChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [updateApiManagementChr.pending]: (state, action) => {
      state.loading = true;
    },
    [updateApiManagementChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [updateApiManagementChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
    [deleteApiManagementChr.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteApiManagementChr.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action?.payload?.data?.message;
    },
    [deleteApiManagementChr.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.message;
    },
  },
});

export const { resetMessage, resetErrMessage, rowSelect } =
  apiManagementChrSlice.actions;
export default apiManagementChrSlice.reducer;
